import { apiBaseUrl } from './config';
import { createApiClient } from './client';
import { tokenStore } from './tokenStore';

/**
 * The app's API client, wired: the address from `REACT_APP_API_URL` (no
 * default: a request without one rejects with `ApiNotConfiguredError`), the
 * token from the secure store, and two events a session layer listens for.
 *
 *   import { api } from '../api';
 *   const { data } = await api.get('/places/search', { query: { q } });
 *
 * Every screen that moves off Supabase calls through this (InGo mobile plan
 * §3); none calls `fetch` itself.
 */
const signedOutHandlers = new Set();
const passwordChangeHandlers = new Set();

export const api = createApiClient({
  baseUrl: () => apiBaseUrl(),
  getToken: () => tokenStore.read(),
  onUnauthenticated: () => {
    tokenStore.clear().catch(() => {});
    signedOutHandlers.forEach((handler) => handler());
  },
  onPasswordChangeRequired: () => {
    passwordChangeHandlers.forEach((handler) => handler());
  },
});

/** Called when the API refuses the token (401): the session layer signs the person out. Returns an unsubscribe. */
export function whenSignedOut(handler) {
  signedOutHandlers.add(handler);
  return () => signedOutHandlers.delete(handler);
}

/** Called on 403 PASSWORD_CHANGE_REQUIRED: the person must choose their own password first. Returns an unsubscribe. */
export function whenPasswordChangeRequired(handler) {
  passwordChangeHandlers.add(handler);
  return () => passwordChangeHandlers.delete(handler);
}

export { tokenStore } from './tokenStore';
export { apiBaseUrl, isApiConfigured, ApiNotConfiguredError } from './config';
export { ApiError, NetworkError, isApiError, isOutcomeUnknown, isRetryable, refusalMessage } from './errors';
